import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { notifySuccess, notifyError } from "src/assets/toastService";
import api from "src/features/auth/axiosConfig";
import CommonButtons from "src/shared/components/CommonButtons";

interface Props {
  onReportGenerated: () => void;
}

const GenerateDailyReport: React.FC<Props> = ({ onReportGenerated }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateReport = async () => {
    if (isGenerating) return;

    setIsGenerating(true);
    const now = new Date();
    const today = now.getFullYear() + "-" +  String(now.getMonth() + 1).padStart(2, "0") + "-" +  String(now.getDate()).padStart(2, "0");


    try {
      await api.get(`/app/v1/reports?date=${today}&export_type=pdf`, { responseType: "arraybuffer" });

      notifySuccess("Daily report generated successfully");
      onReportGenerated();
    } catch (error) {
      console.error(error);
      notifyError("Failed to generate daily report");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <CommonButtons label={"Generate Daily Report"} onClick={generateReport} disabled={isGenerating} className="rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700 disabled:opacity-60" />
      <ToastContainer />
    </div>
  );
};

export default GenerateDailyReport;
